module.exports = __webpack_public_path__ + "static/media/YB5M13_6.1f8fb3af.jpg";